/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const BotMessage = props => {
  const botMessageClasses = cx('Bot-message', props.className);

  return (
    <>
      <div className={botMessageClasses}>
        <div>{props.children}</div>
      </div>
      {props.bubbleText && (
        <>
          <div className="Bot-message__bubble-dot Bot-options__tag-bubble-dot" />
          <div className="Bot-message__bubble-line Bot-options__tag-bubble-line" />
          <div className="Bot-options__tag-bubble-anchor">
            <div className="Bot-message__tag-bubble Bot-options__tag-bubble">
              {props.bubbleText}
            </div>
          </div>
        </>
      )}
    </>
  );
};

BotMessage.propTypes = {
  bubbleText: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};

export default BotMessage;
